import loadable from '@loadable/component';

export const RXDLandingPage = loadable(/* #__LOADABLE__ */ () => import('./RXDLandingPage'));
